// src/api/sfAiDjangoApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { DJANGO_AI_URL } from "../app/api/config"; // make sure this exists
import { AGENT_REGISTRY, HTTP_METHODS } from "../app/Utils/CONST"; // optional if you're using your enum
import { getActiveHotelId } from "../app/Utils/Utils";

export const sfAiDjangoApi = createApi({
  reducerPath: "sfAiDjangoApi",
  baseQuery: fetchBaseQuery({
    baseUrl: DJANGO_AI_URL,
    prepareHeaders: (headers) => {
      let token = localStorage.getItem("token");
      if (token.includes("||master"))
        token = token.replace(/(\|\|master)+$/, "");
      if (token) {
        headers.set("Authorization", `${token}`);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    createConversation: builder.mutation({
      query: ({ userPrompt }) => ({
        url: `/ai-assistant/createConversation`,
        method: HTTP_METHODS.POST,
        params: {
          hotel_id: getActiveHotelId(),
          user_email: localStorage.getItem("HotelEmail"),
        },
        body: {
          conversation_name: userPrompt.slice(0, 20),
        },
      }),
    }),
    sendUserPrompt: builder.mutation({
      query: ({ conversationId, userPrompt, agent }) => ({
        url: `/ai-assistant/user-query`,
        method: "POST",
        params: {
          hotel_id: getActiveHotelId(),
          hotelId: getActiveHotelId(),
          user_email: localStorage.getItem("HotelEmail"),
          conversation_id: conversationId,
          agent: agent || AGENT_REGISTRY.MASTER,
        },
        body: {
          query: userPrompt,
        },
      }),
    }),
    sendAgentQuery: builder.mutation({
      query: ({ userPrompt, agent }) => ({
        url: `/ai-assistant/agentQuery`,
        method: "POST",
        params: {
          hotel_id: getActiveHotelId(),
          hotelId: getActiveHotelId(),
          user_email: localStorage.getItem("HotelEmail"),
          agent: agent,
        },
        body: {
          query: userPrompt,
        },
      }),
    }),
  }),
});

export const {
  useCreateConversationMutation,
  useSendUserPromptMutation,
  useSendAgentQueryMutation,
} = sfAiDjangoApi;
